import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
Vue.use(VueRouter);

const routerM: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/mobile/Home.vue"),
    redirect: "/Login",
    children: [
      {
        path: "/Login",
        name: "Login",
        component: () => import("@/views/mobile/user/Login.vue"),
      },
      {
        path: '/SetPassword',
        name: 'SetPassword',
        component: () => import('@/views/mobile/user/SetPassword.vue'),
      },
    ],
  },
  {
    path: "/MainFrame",
    name: "MainFrame",
    component: () => import("@/views/mobile/MainFrame.vue"),
    children: [
      //super
      {
        path: "/PstQuery",
        name: "PstQuery",
        component: () => import("@/views/mobile/super/PstQuery.vue"),
      },
      {
        path: "/Details/:id",
        name: "Details",
        component: () => import("@/views/mobile/super/Details.vue"),
      },
      //暂由平台管理员使用
      {
        path: "/Negatives",
        name: "Negatives",
        component: () => import("@/views/mobile/manager/Negatives.vue"),
      },
      {
        path: "/Negative",
        name: "Negative",
        component: () => import("@/views/mobile/manager/Negative.vue"),
      },
      {
        path: "/EditNegative/:id",
        name: "EditNegative",
        component: () => import("@/views/mobile/manager/EditNegative.vue"),
      },
      //manager
      {
        path: "/HandleQuery",
        name: "HandleQuery",
        component: () => import("@/views/mobile/manager/HandleQuery.vue"),
      },
      {
        path: "/HandleDetail/:id",
        name: "HandleDetail",
        component: () => import("@/views/mobile/manager/HandleDetail.vue"),
      },
      /*
      {
        path: "/Transfers",
        name: "Transfers",
        component: () => import("@/views/pc/super/Transfers.vue"),
      },

      {
        path: "/ReplyAudits",
        name: "ReplyAudits",
        component: () => import("@/views/pc/super/ReplyAudits.vue"),
      },
      {
        path: "/Transfer/:id",
        name: "Transfer",
        component: () => import("@/views/pc/super/Transfer.vue"),
      },
      {
        path: "/ReplyAudit/:id",
        name: "ReplyAudit",
        component: () => import("@/views/pc/super/ReplyAudit.vue"),
      },


      //负面舆情列表-平台管理员审核
      {
        path: "/PstAudits",
        name: "PstAudits",
        component: () => import("@/views/pc/super/PstAudits.vue"),
      },
      {
        path: "/PstAudit",
        name: "PstAudit",
        component: () => import("@/views/pc/super/PstAudit.vue"),
      },
      // manager
      {
        path: "/Replys",
        name: "Replys",
        component: () => import("@/views/pc/manager/Replys.vue"),
      },
      {
        path: "/Reply/:id",
        name: "Reply",
        component: () => import("@/views/pc/manager/Reply.vue"),
      },
      {
        path: "/ReportPrint/:id",
        name: "ReportPrint",
        component: () => import("@/views/pc/manager/ReportPrint.vue"),
      },
      {
        path: "/Evidences",
        name: "Evidences",
        component: () => import("@/views/pc/manager/Evidences.vue"),
      },
      {
        path: "/Evidence/:id",
        name: "Evidence",
        component: () => import("@/views/pc/manager/Evidence.vue"),
      },


      {
        path: "/NegativeDetail/:id",
        name: "NegativeDetail",
        component: () => import("@/views/pc/manager/NegativeDetail.vue"),
      },
      {
        path: "/HandleDetail/:id",
        name: "HandleDetail",
        component: () => import("@/views/pc/manager/HandleDetail.vue"),
      },
      {
        path: "/HandleQuery",
        name: "HandleQuery",
        component: () => import("@/views/pc/manager/HandleQuery.vue"),
      },
      //admin
      {
        path: "/Parameter",
        name: "Parameter",
        component: () => import("@/views/pc/admin/Parameter.vue"),
      },
      {
        path: "/Supers",
        name: "Supers",
        component: () => import("@/views/pc/admin/Supers.vue"),
      },
      {
        path: "/AddSuper",
        name: "AddSuper",
        component: () => import("@/views/pc/admin/AddSuper.vue"),
      },
      {
        path: "/EditSuper",
        name: "EditSuper",
        component: () => import("@/views/pc/admin/EditSuper.vue"),
      },
      */
      //user
      {
        path: '/My',
        name: 'My',
        component:  () => import("@/views/mobile/user/My.vue"),
      },
      //网站设置
      {
        path: '/Parameter',
        name: 'Parameter',
        component:  () => import("@/views/mobile/admin/Parameters.vue"),
      },
      {
        path: "/Password",
        name: "Password",
        component: () => import("@/views/mobile/user/Password.vue"),
      },
      {
        path: "/About",
        name: "About",
        component: () => import("@/views/mobile/user/About.vue"),
      },
    ],
  },
];

export default routerM;
